import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { I18N } from 'commons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import v from 'scss/v';

const AlertBox = ({ message, isSavedSucceed }) => {
  const alertBox = useRef(null)
  useEffect(() => {
    if (isSavedSucceed) {
      // focus after alert box display
      setTimeout(() => {
        alertBox && alertBox.current.focus()
      }, 5);
    }
  }, [isSavedSucceed])

  return (
    isSavedSucceed && 
    <div className="row" ref={alertBox} tabIndex={-1} eb-test="save_success_alert">
      <div className="col-12">
        <div className="alert alert-success text-left">
          <FontAwesomeIcon icon={faCheckCircle} color={v('$green-7')} width="1em" height="1em"/>
          <div className='ml-2'>
            <b><I18N>home.alert.box.title.success</I18N></b>
            <p className='mb-0'><I18N>{message}</I18N></p>
          </div>
        </div>
      </div>
    </div>
  )
}

AlertBox.propTypes = {}

export default AlertBox
